import { Button, Flex, Loader, Select, Skeleton, TextInput } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import showNotification from "../../utils/showNotification";
import { ERROR_HANDLER } from "../../utils/error-handler";
import axios from "axios";


export default function LibraryContentFilters() {

   const [SPECIALTIES, setSpecialties] = useState(null)
   const [isLoading, setIsLoading] = useState(false)

   useEffect(() => {
      const getSpecialties = async () => {
         try {
            setIsLoading(true)
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}info/specialties/`)
            if (data) {
               const specialtiesData = data.map((specialty) => {
                  return {
                     value: specialty.name,
                     label: specialty.name
                  }
               })
               setSpecialties(specialtiesData)
            }
            return
         } catch (error) {
            console.log(error)
            return showNotification({
               color: "red",
               status: "error",
               title: "Ha ocurrido un problema al cargar las especialidades.",
               message: `Detalle: ${ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}`
            })
         } finally {
            setIsLoading(false)
         }
      }
      getSpecialties()
   }, [])

   const [searchParams, setSearchParams] = useSearchParams();
   const currentSearch = searchParams.get("search") || "";
   const currentSpecialty = searchParams.get("specialty") || "";

   const [inputValue, setInputValue] = useState(currentSearch);
   const [selectedSpecialty, setSelectedSpecialty] = useState(currentSpecialty);

   const updateSearchParam = (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) {
         newParams.set(key, value);
      } else {
         newParams.delete(key);
      }
      setSearchParams(newParams);
   };

   const onSearchSubmit = (e) => {
      e.preventDefault();
      updateSearchParam("search", inputValue || null);
   };

   const onSpecialtyChange = (value) => {
      setSelectedSpecialty(value || "");
      updateSearchParam("specialty", value);
   };

   return (
      <form onSubmit={onSearchSubmit}>
         <Flex direction={{ base: "column", sm: "row" }} gap={12} align="end">

            {isLoading
               ? <div
                  style={{
                     display: "grid",
                     placeItems: 'center',
                     minWidth: '250px',
                     maxHeight: "36px",
                     backgroundColor: "red",
                     borderRadius: "var(--border-radius-sm)"
                  }}
               >
                  < Skeleton  w={'100%'} h={"36px"} />
               </div>
               : (!isLoading && (!SPECIALTIES || SPECIALTIES?.length === 0))
                  ? <></>
                  : <Select
                     placeholder="Filtrar por especialidad"
                     value={selectedSpecialty}
                     onChange={onSpecialtyChange}
                     clearable
                     data={SPECIALTIES}
                  />
            }

            <TextInput
               placeholder="Buscar por título o autor"
               value={inputValue}
               onChange={(e) => setInputValue(e.currentTarget.value)}
            />
            <Button type="submit">Buscar</Button>

         </Flex>
      </form>
   );
}
